/**
 * 验证工具函数集合
 */

export const INVITE_CODE_MIN_LENGTH = 8;
export const INVITE_CODE_LENGTH = 20;

// 验证码格式验证
export const validateVerificationCode = (code: string): { isValid: boolean; error?: string; } => {
  const trimmed = code.trim();

  if (!trimmed) {
    return { isValid: false };
  }

  if (trimmed.length !== 6) {
    return { isValid: false };
  }

  return { isValid: true };
};

// 邀请码格式验证
export const validateInviteCode = (code: string): { isValid: boolean; error?: string; } => {
  const trimmed = code.trim();

  // 邀请码是可选的，空值视为有效
  if (!trimmed) {
    return { isValid: true };
  }

  if (trimmed.length < INVITE_CODE_MIN_LENGTH || trimmed.length > INVITE_CODE_LENGTH) {
    return { isValid: false };
  }

  const inviteCodeRegex = new RegExp(`^[a-zA-Z0-9]{${INVITE_CODE_MIN_LENGTH},${INVITE_CODE_LENGTH}}$`);
  if (!inviteCodeRegex.test(trimmed)) {
    return { isValid: false };
  }

  return { isValid: true };
};

// 清理代码输入（只保留字母数字，限制长度）
export const cleanCodeInput = (value: string, maxLength = 6): string => {
  return value.replace(/[^a-zA-Z0-9]/g, '').slice(0, maxLength);
};
